<ng-container *transloco="let t; read: 'accounts'">
<div id="userAccountModal" class="rounded-lg fix-action-row modal-body">
  <div class="flex justify-between border-b">
    @if (userDetails) {
      <h1 class="text-[25px] font-bold">
        {{ t('common.editingTitle', { name: userDetails.firstName + ' ' + userDetails.lastName }) }}
      </h1>
    }
    @if (!userDetails) {
      <h1 class="text-[25px] font-bold">{{ t('userAccount.addUser') }}</h1>
    }
    <i
      mat-button
      mat-dialog-close
      class="text-drdpblue-300 cursor-pointer uil uil-times-circle"
    ></i>
  </div>

  <div mat-dialog-content>
    <form
      class="grid grid-cols-2 gap-4 gap-x-10 mt-2 pb-3"
      [formGroup]="userForm"
      >
      <div class="col-span-1">
        <mat-form-field class="bg-white" appearance="fill">
          <label> {{ t('common.workTitle') }} </label>
          <input
            matInput
            [placeholder]="t('common.workTitle')"
            autocomplete="off"
            type="text"
            formControlName="jobTitle"
            maxlength="50"
            />
        </mat-form-field>
      </div>

      <div class="col-span-1">
        <mat-form-field class="bg-white" appearance="fill">
          <label class="required"> {{ t('common.firstName') }} </label>
          <input
            matInput
            [placeholder]="t('common.firstName')"
            autocomplete="off"
            type="text"
            formControlName="firstName"
            maxlength="50"
            />
        </mat-form-field>
      </div>

      <div class="col-span-1">
        <mat-form-field class="bg-white" appearance="fill">
          <label> {{ t('addEditUser.middleInitial') }} </label>
          <input
            matInput
            [placeholder]="t('addEditUser.middleInitial')"
            autocomplete="off"
            type="text"
            formControlName="middleName"
            maxlength="1"
            />
        </mat-form-field>
      </div>

      <div class="col-span-1">
        <mat-form-field class="bg-white" appearance="fill">
          <label class="required"> {{ t('common.lastName') }} </label>
          <input
            matInput
            [placeholder]="t('common.lastName')"
            autocomplete="off"
            type="text"
            formControlName="lastName"
            maxlength="50"
            />
        </mat-form-field>
      </div>

      <div class="col-span-1">
        <mat-form-field class="bg-white" appearance="fill">
          <label class="required"> {{ t('common.accountEmail') }} </label>
          <input
            matInput
            class="relative z-50"
            [placeholder]="t('common.accountEmail')"
            autocomplete="off"
            type="email"
            formControlName="workEmail"
            maxlength="100"
            />
          @if (workEmail.touched && workEmail.errors?.email) {
            <mat-error
              class="text-sm text-red-700 pt-4"
              >
              {{ t('common.invalidEmail') }}
            </mat-error>
          }
          @if (
            !workEmail.errors?.email && workEmail.duplicateEmail && !editData
            ) {
            <mat-error
              class="text-sm text-red-700 pt-4"
              >
              {{ t('addEditUser.emailTaken') }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      @if (!editData) {
        <div class="col-span-1">
          <mat-form-field class="bg-white" appearance="fill">
            <label class="required"> {{ t('addEditUser.confirmEmail') }} </label>
            <input
              matInput
              class="relative z-50"
              type="email"
              [placeholder]="t('addEditUser.confirmEmailPlaceholder')"
              matInput
              formControlName="checkEmail"
              maxlength="100"
              />
            @if (
              checkEmail.touched &&
              checkEmail.errors?.emailMismatch &&
              !editData
              ) {
              <mat-error
                class="text-sm text-red-700 pt-4"
                >
                {{ t('addEditUser.emailMismatch') }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }

      <div class="col-span-1">
        <drdp-select-suffix
          [initialSuffix]="selectedSuffix"
          (suffix)="handleDropdown($event, selectType.Suffix)"
          >
        </drdp-select-suffix>
      </div>

      @if (userDetails) {
        <div class="col-span-1">
          <div class="mt-2">
            <label> {{ t('common.accountCreated') }} </label>
            <p>{{ userDetails.createdOn | localDate }}</p>
          </div>
        </div>
      }

      @if (userDetails) {
        <div class="col-span-1">
          <div class="mt-2">
            <label> {{ t('common.lastLogin') }} </label>
            <p>{{ userDetails.lastLogin | localDate }}</p>
          </div>
        </div>
      }

      <div class="col-span-1 select-input flex-col justify-center items-center">
        <drdp-select-status
          [disabled]="!hasStatusEditAccess"
          [initialStatusId]="statusTypeId.value"
          (status)="handleDropdown($event, selectType.Status)"
          [required]="true"
          >
        </drdp-select-status>
      </div>

      @if (!activeUser) {
        <div class="col-span-2">
          <label>{{ t('addEditUser.revokeReason') }}</label>
          <mat-form-field appearance="outline">
            <textarea
              formControlName="statusReason"
              matInput
              [placeholder]="t('addEditUser.revokeReasonPlaceholder')"
              maxlength="100"
            ></textarea>
          </mat-form-field>
        </div>
      }

      @if (userDetails) {
        <div class="col-span-1">
          <div>
            <label> {{ t('common.statusModifiedDate') }} </label>
            <p>{{ userDetails.modifiedOn | localDate }}</p>
          </div>
        </div>
      }

      @if (userDetails) {
        <div class="col-span-1">
          <div class="mt-2">
            <label> {{ t('common.statusModifiedBy') }} </label>
            <p>{{ userDetails.modifiedName }}</p>
          </div>
        </div>
      }

      @if (userDetails) {
        <div class="col-span-1">
          <div class="mt-2">
            <label> {{ t('addEditUser.passwordStatus') }} </label>
            <p>
              {{ t('addEditUser.passwordLastChanged', { date: (userDetails.passwordChangedOn | localDate) }) }}
            </p>
          </div>
        </div>
      }

      <div class="col-span-2 items-center w-[100%]">
        <p>
          {{ t('addEditUser.affiliationRequired') }}
        </p>
      </div>

      <div class="col-span-1 items-center w-[100%]">
        <drdp-select-state
          [initialStateId]="state.value"
          (state)="handleDropdown($event, selectType.States)"
          [required]="true"
          [isValid]="isDropdownValid.state"
          >
        </drdp-select-state>
      </div>

      <div class="col-span-1 items-center w-[100%]">
        <drdp-select-region
          [stateId]="state.value"
          [initialRegionId]="region.value"
          [multiSelectInitVals]="true"
          [multiSelect]="true"
          (region)="handleDropdown($event, selectType.RegionRef)"
          >
        </drdp-select-region>
      </div>

      <div class="col-span-1 items-center w-[100%]">
        <drdp-select-county
          [initialCountyIds]="selectedCountyIds"
          (county)="handleDropdown($event, selectType.County)"
          [stateId]="selectedState"
          [clear]="clearDropdown"
          >
        </drdp-select-county>
      </div>

      <div class="col-span-1 items-center w-[100%]">
        <drdp-select-agency
          [initialAgencyId]="agencyId.value"
          (agency)="handleDropdown($event, selectType.Agencies)"
          [stateId]="selectedState"
          [clear]="clearDropdown"
          [isEditDropdown]="true"
          >
        </drdp-select-agency>
      </div>

      <div class="col-span-1 items-center w-[100%]">
        <drdp-select-site
          [initialSiteIds]="sites.value"
          (site)="handleDropdown($event, selectType.Sites)"
          [agencyId]="agencyId.value"
          [multiSelect]="true"
          [multiSelectInitVals]="true"
          [clear]="clearDropdown"
          [required]="agencyId.value"
          [isValid]="sites.valid"
          >
        </drdp-select-site>
      </div>

      @if (loggedInUserAccessLevel >= roleGroupAccessLevel.LeadAdminRoles) {
        <div
          class="col-span-1 items-center w-[100%]"
          >
          <drdp-select-grantee
            [initialGranteeId]="selectedGranteeAgencyId"
            [label]="t('addEditUser.granteeLabel')"
            (agency)="handleDropdown($event, selectType.Grantee)"
            [stateId]="state.value"
            >
          </drdp-select-grantee>
        </div>
      }

      @if (loggedInUserAccessLevel >= roleGroup.LeadAdminRoles) {
        <div
          class="col-span-1 items-center w-[100%]"
          >
          <drdp-select-contractor
            [initialContractorId]="selectedContractorAgencyId"
            [label]="t('addEditUser.contractorLabel')"
            (agency)="handleDropdown($event, selectType.StatePreschoolContractorRef)"
            [stateId]="state.value"
            >
          </drdp-select-contractor>
        </div>
      }

      <div>
        <drdp-select-age-grade
          #ageGroupInstrumentSelect
          [initialageGradeId]="excludedAgeGradeIds.value"
          [label]="t('addEditUser.excludedInstruments')"
          [stateId]="selectedState"
          [multiSelect]="true"
          (ageGrade)="handleDropdown($event, selectType.AgeInstrument)"
          >
        </drdp-select-age-grade>
      </div>

      <div class="col-span-2 items-center w-[100%]">
        <label class="required">{{ t('common.roles') }}</label>
        <!-- Role names and tooltips below are server-supplied: localized by the API, not by Transloco. -->
        <div class="grid grid-cols-2 gap-4 gap-x-10 mt-2 pb-3">
          @if (loggedInUserAccessLevel >= roleGroupAccessLevel.UserRoles) {
            <div
              class="col-span-1 items-center w-[100%]"
              >
              <label>{{ t('common.roleGroups.userRoles') }}</label>
              <div class="flex flex-col">
                @for (role of userRoleOptions; track role) {
                  <div>
                    @if (role.roleGroupId === roleGroup.UserRoles) {
                      <div>
                        <p>
                          <mat-checkbox
                            [checked]="initializeCheckbox(role)"
                            (change)="handleCheckbox(role)"
                            color="primary"
                            >
                          </mat-checkbox>
                          {{ role.roleName }}
                          @if (role.tooltipInformation) {
                            <i class="uil uil-info-circle text-xs" [matTooltip]="role.tooltipInformation"></i>
                          }
                        </p>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }

          @if (loggedInUserAccessLevel >= roleGroupAccessLevel.EnrollmentUser) {
            <div
              class="col-span-1 items-center w-[100%]"
              >
              <label>{{ t('common.roleGroups.enrollmentUser') }}</label>
              <div class="flex flex-col">
                @for (role of userRoleOptions; track role) {
                  <div>
                    @if (role.roleGroupId === roleGroup.EnrollmentUser) {
                      <div>
                        <p>
                          <mat-checkbox
                            [checked]="initializeCheckbox(role)"
                            (change)="handleCheckbox(role)"
                            color="primary"
                            >
                          </mat-checkbox>
                          {{ role.roleName }}
                          @if (role.tooltipInformation) {
                            <i class="uil uil-info-circle text-xs" [matTooltip]="role.tooltipInformation"></i>
                          }
                        </p>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }

          @if (loggedInUserAccessLevel > roleGroupAccessLevel.AdministratorRoles || canEditSameLevelNotPromote) {
            <div
              class="col-span-1 items-center w-[100%]"
              >
              <label>{{ t('common.roleGroups.administratorRoles') }}</label>
              <div class="flex flex-col">
                @for (role of userRoleOptions; track role) {
                  <div>
                    @if (role.roleGroupId === roleGroup.AdministratorRoles) {
                      <div>
                        <p>
                          <mat-checkbox
                            [checked]="initializeCheckbox(role)"
                            (change)="handleCheckbox(role)"
                            [disabled]="role.id === roleType.AgencyAdministrator && canEditSameLevelNotPromote && (loggedInUserAccessLevel <= roleGroup.AdministratorRoles)"
                            color="primary"
                            >
                          </mat-checkbox>
                          {{ role.roleName }}
                          @if (role.tooltipInformation) {
                            <i class="uil uil-info-circle text-xs" [matTooltip]="role.tooltipInformation"></i>
                          }
                        </p>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }

          @if (loggedInUserAccessLevel > roleGroupAccessLevel.LeadAdminRoles) {
            <div
              class="col-span-1 items-center w-[100%]"
              >
              <label>{{ t('common.roleGroups.leadAdminRoles') }}</label>
              <div class="flex flex-col">
                @for (role of userRoleOptions; track role) {
                  <div>
                    @if (role.roleGroupId === roleGroup.LeadAdminRoles) {
                      <div>
                        <p>
                          <mat-checkbox
                            [checked]="initializeCheckbox(role)"
                            (change)="handleCheckbox(role)"
                            color="primary"
                            >
                          </mat-checkbox>
                          {{ role.roleName }}
                          @if (role.tooltipInformation) {
                            <i class="uil uil-info-circle text-xs" [matTooltip]="role.tooltipInformation"></i>
                          }
                        </p>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
          @if (loggedInUserAccessLevel > roleGroupAccessLevel.StateUsers) {
            <div
              class="col-span-1 items-center w-[100%]"
              >
              <label>{{ t('common.roleGroups.stateUsers') }}
                <i class="uil uil-info-circle text-xl ml-2 mb-2 cursor-pointer "
                  [matTooltip]="t('addEditUser.stateUsersTooltip')"
                matTooltipPosition="right" matTooltipClass="custom-tooltip"></i>
              </label>
              <div class="flex flex-col">
                @for (role of userRoleOptions; track role) {
                  <div>
                    @if (role.roleGroupId === roleGroup.StateUsers) {
                      <div>
                        <p>
                          <mat-checkbox
                            [checked]="initializeCheckbox(role)"
                            (change)="handleCheckbox(role)"
                            [disabled]="role.id === roleType.AgencyAdministrator && canEditSameLevelNotPromote && (loggedInUserAccessLevel <= roleGroup.AdministratorRoles)"
                            color="primary"
                            >
                          </mat-checkbox>
                          {{ role.roleName }}
                          @if (role.tooltipInformation) {
                            <i class="uil uil-info-circle text-xs" [matTooltip]="role.tooltipInformation"></i>
                          }
                        </p>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
          @if (loggedInUserAccessLevel >= roleGroupAccessLevel.PowerUserRoles && canEditSameLevel) {
            <div
              class="col-span-1 items-center w-[100%]"
              >
              <label>{{ t('common.roleGroups.powerUserRoles') }}</label>
              <div class="flex flex-col">
                @for (role of userRoleOptions; track role) {
                  <div>
                    @if (role.roleGroupId === roleGroup.PowerUserRoles) {
                      <div>
                        <p>
                          <mat-checkbox
                            [checked]="initializeCheckbox(role)"
                            (change)="handleCheckbox(role)"
                            color="primary"
                            >
                          </mat-checkbox>
                          {{ role.roleName }}
                          @if (role.tooltipInformation) {
                            <i class="uil uil-info-circle text-xs" [matTooltip]="role.tooltipInformation"></i>
                          }
                        </p>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }

          @if (loggedInUserAccessLevel >= roleGroupAccessLevel.SystemPowerUser && canEditSameLevel) {
            <div
              class="col-span-1 items-center w-[100%]"
              >
              <label>{{ t('common.roleGroups.systemPowerUser') }}</label>
              <div class="flex flex-col">
                @for (role of userRoleOptions; track role) {
                  <div>
                    @if (role.roleGroupId === roleGroup.SystemPowerUser) {
                      <div>
                        <p>
                          <mat-checkbox
                            [checked]="initializeCheckbox(role)"
                            (change)="handleCheckbox(role)"
                            color="primary"
                            >
                          </mat-checkbox>
                          {{ role.roleName }}
                          @if (role.tooltipInformation) {
                            <i class="uil uil-info-circle text-xs" [matTooltip]="role.tooltipInformation"></i>
                          }
                        </p>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </form>
  </div>
</div>
<div mat-dialog-actions class="flex justify-end">
  <drdp-btn color="cancel" mat-button mat-dialog-close>{{ t('common.cancel') }}</drdp-btn>
  <drdp-btn
    class="ml-3"
    mat-button
    (click)="onSubmit()"
    [disabled]="userForm.invalid || isSubmitting"
    cdkFocusInitial
    >{{ t('common.save') }}</drdp-btn
    >
  </div>
</ng-container>
